
























import {fieldProps} from '../BZCore/ActiveField'
import Vue from 'vue'
import Errors from '../errors.vue'
import UiInlineIcon from '../../Icon/InlineIcon.vue'
import StringInput from '../../Inputs/StringInput.vue'

export default Vue.extend({
  name: 'StringField',
  props: fieldProps,
  components: {Errors, UiInlineIcon, StringInput},
  created () {
    if (!this.value && this.defaultValue) {
      this.$emit('input', this.defaultValue)
    }
  },
  watch: {
    defaultValue (newValue, oldValue) {
      if (!this.value || this.value === oldValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    onInput (event: string) {
      this.$emit('input', event)
    },
    onBlur (event: UIEvent) {
      this.$emit('blur', event)
      if (this.fieldOptions.capitalize) {
        this.capitalize();
      }
    },
    capitalize (): void {
      if (this.currentValue) {
        this.$emit('input', this.currentValue.replace(/(^|\s)\S/g, l => l.toUpperCase()))
      }
    }
  },
  computed: {
    currentValue: {
      get (): string {
        if (this.value && this.value.toString) {
          return this.value.toString()
        }
        return this.value as string || ''
      },
      set () {

      }
    },
    fieldType (): string {
      if (this.fieldOptions.type) {
        return this.fieldOptions.type as string
      } else {
        return 'text'
      }
    },
    textAreaRows (): number {
      if (this.fieldOptions.rows) {
        return this.fieldOptions.rows as number
      } else {
        return 2;
      }
    }
  }
})
